// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_lw-0";